var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "New_Analyst" }, [
    _c("div", {
      staticClass: "dateNewAnalyst",
      domProps: { innerHTML: _vm._s(_vm.postDate) },
    }),
    _vm._v(" "),
    _c("h2", { staticClass: "tt" }, [
      _c("a", {
        attrs: { href: _vm.post.postUrl },
        domProps: { innerHTML: _vm._s(_vm.post.title) },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }